import $ from 'jquery';
import 'bootstrap/js/dist/modal';

$(document).ready(function() {
  $('.select_all').click(function() {
    $(this).closest('.modal').find('textarea').select();
  });
});

